// 菜单栏组件最多支持三层
<template>
	<a-menu :default-selected-keys="[activeIndex]" :default-open-keys="activeOpenIndex" :open-keys="openKeys"
		:selected-keys="[activeIndexSelf]" :mode="MENUCONFIG.STYLE.isTop ? 'horizontal' : 'inline'"
		:theme="MENUCONFIG.STYLE.theme" @click="handleSelect" @openChange="onOpenChange">
		<template v-for="item in menuData">

			<a-menu-item v-if="!item.subnav" :key="item.menuCode">
				<a-icon type="home" /><span>{{ item.menuName }}</span>
			</a-menu-item>

			<a-sub-menu v-else :key="item.menuCode">
				<span slot="title"><a-icon :type="getIcon(item.icon)" />
					<!-- 消息未读数量 -->
					<a-badge v-if="messageMap[item.menuCode]" :count="getMenuMsgCount(messageMap[item.menuCode])"
						:offset="[15, -2]"><span>{{ item.menuName }}</span></a-badge>
					<span v-else>{{ item.menuName }}</span>
				</span>
				<template v-for="sub in item.subnav">
					<a-menu-item v-if="!sub.subnav" :key="sub.menuCode">
						<span>
							<span class="spont"></span>
							<!-- 消息子菜单菜单未读数量 -->
							<a-badge v-if="messageMap[item.menuCode] && messageMap[item.menuCode][sub.path]"
								:count="$store.getters['home/getMessageCount'][messageMap[item.menuCode][sub.path]]"
								:offset="[18, -1]">{{ sub.menuName }}</a-badge>
							<span v-else>{{ sub.menuName }}</span>
						</span>
					</a-menu-item>
					<a-sub-menu v-else :key="sub.menuCode">
						<span slot="title"><span>{{ sub.menuName }}</span></span>
						<a-menu-item v-for="subson in sub.subnav" :key="subson.menuCode">
							<span><span class="spont"></span>{{ subson.menuName }}</span>
						</a-menu-item>
					</a-sub-menu>
				</template>

			</a-sub-menu>
		</template>
	</a-menu>
</template>

<script>
export default {
	props: {
		menuData: {
			type: [Array, Object],
			required: true
		},
		activeIndex: {
			type: [String],
			required: false
		},
		activeOpenIndex: {
			type: [Array],
			required: false
		}
	},
	name: 'menu-tree',
	data() {
		return {
			activeIndexSelf: this.activeIndex,
			openKeys: this.activeOpenIndex.length > 0 ? [this.utils.deepClone(this.activeOpenIndex)[0]] : [],
			messageMap: {
				"MENU0400": {
					"circulation/goldcheck": "queryGoldPage",
					"review/bill-issue": "reviewGold",
					"review/exdate-change": "reviewGoldModified",
					"review/pay": "reviewGoldPay",
					"review/financing": "reviewFinance",
					"review/cashing": "toReviewVoucher",
					"review/guarantee": "reviewGoldGuarantee",
				},
				"MENU0700": {
					"notice/transferNotice": "noticeList"
				}
			}
		}
	},
	mounted() {
		// 查询消息未读数量
		this.$store.dispatch("home/getMessageCount");
	},
	methods: {
		// 计算一级菜单的未读消息之和
		getMenuMsgCount(obj) {
			let sum = 0;
			for (let k in obj) {
				sum += this.$store.getters['home/getMessageCount'][obj[k]] || 0
			}
			return sum;
		},
		handleSelect(data) {
			this.activeIndexSelf = data.key;
			this.$emit("handleSelect", data);
		},
		// 老项目后台icon数据为 anticon-xxx-o 格式，此处做了转换只取中间部分
		getIcon(icon) {
			if (icon) {
				icon = icon.replace("anticon-", "");
				if (icon.substring(icon.length - 2, icon.length) == "-o") {
					icon = icon.substring(0, icon.length - 2);
				}
			}
			return icon;
		},
		onOpenChange(openKeys) {
			this.openKeys = openKeys[openKeys.length - 1] ? [openKeys[openKeys.length - 1]] : [];
		},
	},
	watch: {
		activeIndex(newValue) {
			this.activeIndexSelf = newValue;
			this.openKeys = [this.activeIndexSelf.split("_")[0]];
		}
	}
}
</script>

<style scoped="scoped" lang="less">
:focus {
	outline: 0 !important;
}

.spont {
	display: inline-block;
	width: 4px;
	height: 4px;
	border-radius: 100%;
	background: #fff;
	position: absolute;
	left: 29px;
	top: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components-frame/menu/menu-tree.vue